import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
const Wrapper = styled.div`
  padding: 12px 6px;

  h5 {
    font-weight: bold;
    margin: 0 0 6px;
  }
`;
const TabDisabledTimeRange = () => {
  const { t } = useTranslation("search");
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement("h5", null, t("time_range.no_override_title")), /* @__PURE__ */ React.createElement("p", null, t("time_range.no_override_hint")));
};
export default TabDisabledTimeRange;
